<template>
  <div>
    <div class="top">
      <Breadcrumb :options="breadcrumb" />
      <Wxts :wxtsList="wxtsList" />
    </div>

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="generatProfit">生成利润</el-button>
        </el-form-item>
      </template>
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`车队利润表`)">导出</el-button>
        </el-form-item>
      </template>
      
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />

    <Dialog class="dialog" ref="dialog" :title="title" @closed="dialogClosed" :width="'940px'">
      <template #default>
        <el-form class="searchForm" :model="modalSearchForm">
          <el-checkbox class="checkAll" :indeterminate="isIndeterminate" v-model="checkAll"
            @change="handleCheckAllChange">全选
          </el-checkbox>

          <FormItem v-for="(c, i) in modalSearchFormCtrl" :key="'msformItem' + i" :viewMode="false" :config="c"
            :options="c.options" :inputValue="modalSearchForm[c.keyName]" @onChange="onModalSearchFormChange" />
        </el-form>

        <el-scrollbar class="content-h">
          <el-checkbox-group class="list" v-model="checkedIds" @change="onCheckChange">
            <el-checkbox class="item" v-for="(c, i) in modalList" :key="'itemm' + i" :label="c.id">
              <!--<div class="row0">{{ c.license }}-{{ c.driver }}</div>-->
              <div class="basic">
                <span>{{ c.license }}</span><span>{{ c.driver }}</span>
              </div>
              <!--<div class="row1">
                <div class="label">出勤天数</div>
                <div class="content">
                  <input type="text" v-model="c.unattendance" readonly>
                  <div class="unit">天</div>
                </div>
              </div>-->
              <!--<div class="sel">
                <span>出勤<input type="text" v-model="c.unattendance" readonly>天</span>
              </div>-->
            </el-checkbox>
          </el-checkbox-group>
        </el-scrollbar>

        <div class="btns">
          <el-button type="primary" @click="onModalSubmit">确 定</el-button>
          <el-button @click="hideDialog">取 消</el-button>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import { mapState, mapMutations } from "vuex";

export default {
  name: "FinanceEstimatedProfit",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'money',
      breadcrumb: [
        { name: "财务管理" },
        { name: "车队利润表" },
      ],
      wxtsList: [
        {
          name: '毛利额=运费总额-出车费用-固定费用-维保费用-附加费用-亏吨金额+补差金额'
        },
      ],
      formInline: {
        month: '',
        fleet: null,
        license: '',
      },
      formCtrl: [
        {
          ...this.ctrls.fleet,
          options: [],
        },
        {
          ...this.ctrls.license,
          label: '车牌号',
        },
        {
          ...this.ctrls.month,
        },
      ],
      cols: [
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 120 },
        { keyName: "allorder", label: "运费总额", align: 'right', className: 'pr30', minwidth: 120 },
        // { keyName: "basemoney", label: "司机工资", align: 'right', className: 'pr30', minwidth: 120 },
        // { keyName: "escort", label: "押运员工资", align: 'right', className: 'pr30', minwidth: 120 },
        // { keyName: "unattendance", label: "出勤天数", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "gomoney", label: "出车费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "allfixed", label: "固定费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "allrepair", label: "维保费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "additional", label: "附加费用", align: 'right', className: 'pr30', minwidth: 120 },
        //{ keyName: "alloil", label: "总油费", align: 'right', className: 'pr30', minwidth: 120 },
        // { keyName: "eswage", label: "利润奖金", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dtonprices", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "compen", label: "补差金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "groprofit", label: "毛利额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "fuel", label: "综合油耗", align: 'right', className: 'pr30', minwidth: 120 },
        // { keyName: "profit", label: "净利润", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      getTotalProperty: [
        'basemoney',
        'allorder',
        'escort',
        'gomoney',
        'message',
        'allrepair',
        'unattendance',
        'allfixed',
        //'alloil',
        'compen',
        'dtonprices',
        'profit',
        'groprofit',
        'eswage',
        'additional',
      ],
      btns: [
        {
          title: '查看当月运单',
          img: require('@/assets/img/icon_order.png'),
          unimg: require('@/assets/img/icon_order_hover.png'),
          cb: ({ month, license }) => {
            this.$router.push(
              `/finance/monthorder?month=${month}&license=${license}`
            );
          },
        },
        {
          title: '查看当月维保记录',
          img: require('@/assets/img/icon_maintenance.png'),
          unimg: require('@/assets/img/icon_maintenance_hover.png'),
          cb: ({ month, license, carid }) => {
            this.$router.push(
              `/finance/monthfixrecord?month=${month}&license=${license}&car_id=${carid}`
            );
          },
        },
      ],
      baseParams: ['month'],
      title: '车辆预计利润生成',
      modalSearchForm: {},
      modalSearchFormCtrl: [
        {
          label: "月份选择：",
          keyName: "month",
          type: "select",
          options: []
        },
      ],
      modalList: [],
      checkedIds: [],
      checkAll: false,
      isIndeterminate: false,
      team: [],
    };
  },
  computed: {
    ...mapState([
      'store'
    ]),
  },
  methods: {
    ...mapMutations([
      'setState'
    ]),
    onSearchItemChange({ key }) {
      // console.log(key)
      if (['fleet', 'month'].includes(key)) {
        this.page = 1;
        this.getList()
        this.getOptions({ fleet: this.formInline.fleet })
      }
    },
    generatProfit() {
      this.showDialog()
    },
    onModalSearchFormChange({ key, value }) {
      // console.log(key, value)
      this.modalSearchForm[key] = value;
      this.modalSearchReq()
      console.log({ ...this.modalSearchForm })
    },
    modalSearchReq() {
      this.post(`${this.baseUrl}/updatemonth`, this.modalSearchForm, ({ car }) => {
        this.modalList = [...car]
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    handleCheckAllChange(val) {
      const arr = this.modalList.map(v => v.id)
      // console.log(val)
      this.checkedIds = val ? arr : [];
      this.isIndeterminate = false;
    },
    onCheckChange(v) {
      // console.log(v)
      // console.log(this.checkedIds)
      let n = v.length
      this.checkAll = n === this.modalList.length
      this.isIndeterminate = n > 0 && n < this.modalList.length
    },
    onModalSubmit() {
      if (!this.checkedIds.length) {
        this.$message({
          type: 'warning',
          message: '请至少选择1辆车!',
        });
        return
      }
      this.loading = true
      let url = `${this.baseUrl}/addedu`;
      const params = {
        userid: this.user.id,
        ...this.modalSearchForm,
        car_id: this.checkedIds,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList()
          this.hideDialog()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    dialogClosed() {
      this.checkedIds = []
      this.checkAll = false
      this.isIndeterminate = false
    },
    setOptions({ month, car }) {
      this.modalSearchFormCtrl[0].options = month.map(v => {
        return {
          label: v,
          value: v,
        }
      })
      this.modalSearchForm.month = month[0]

      this.modalList = [...car]
    },
    setFleet({ team }) {
      console.log(team)
      this.formCtrl.map(v => {
        if (v.keyName == 'fleet') {
          this.setCtrlOption(v, team, 'nickname')
        }
      })
      // this.formInline.fleet = team[0].id
      this.MONTH = this.formInline.month = this.CURR_MONTH
      // this.modalSearchForm.fleet = team[0].id
      this.$forceUpdate()
      this.$nextTick(() => {
        this.getList()
        this.getOptions({ fleet: this.formInline.fleet })
      });
    },
  },
  // watch: {
  //   $route() {
  //     this.setParams()
  //   },
  // },
  mounted() {
    this.getFleet()
    // this.getList() 
  },
};
</script>

<style lang="less" scoped>
.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;

  /deep/ .wxts {
    .b {
      width: 350px;
    }
  }
}

.dialog {
  /deep/ .el-dialog {
    width: 90%;
    height: 547px;

    .el-dialog__body {
      padding: 11px 20px 30px;

    }
  }

  .content-h {
    height: 350px;
    overflow-x: hidden;

    /deep/ .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    /deep/ .is-horizontal {
      display: none;
    }
  }

  .searchForm {
    display: flex;

    .checkAll {
      padding: 10px 30px 10px 0px;
    }

    /deep/ .el-form-item {
      .el-form-item__content {
        .el-input {
          input {
            background: #F2F6FC;
          }
        }
      }

      &:not(:first-of-type) {
        margin-left: 15px;
      }
    }
  }

  .list {
    display: flex;
    flex-wrap: wrap;
    // line-height: 20px;

    .item {
      position: relative;
      width: 167px;
      height: 43px;
      //line-height: 24px;
      //padding: 10px;
      margin: 0 15px 15px 0;
      border: 1px solid #E2E6F0;
      border-radius: 6px;
      color: #000;
      font-size: 14px;
      background-color: #FAFAFA;

      // &:nth-child(4n) {
      //   margin-right: 0;
      // }

      &.is-checked {
        border-color: #2691FF;
      }

      /deep/ .el-checkbox__input {
        //display: none;
        position: absolute;
        right: 15px;
        top: 14px;
      }

      /deep/ .el-checkbox__label {
        padding: 0;
        width: 100%;
      }

      // .row0 {
      //   display: flex;
      //   margin: 5px 0;
      // }
      .basic {
        height: 43px;
        line-height: 43px;
        overflow: hidden;
        margin: 0 auto;
        padding: 0 15px;
        //border-bottom: 1px solid #EBEEF5;

        span:first-child {
          font-size: 14px;
          color: #303133;
        }

        span:nth-child(2) {
          margin-left: 5px;
          font-size: 14px;
          color: #909399;
        }
      }

      .sel {
        height: 34px;
        line-height: 34px;
        overflow: hidden;
        margin: 0 auto;
        padding: 0 15px;

        input {
          width: 18px;
          text-align: center;
        }
      }

      .row1 {
        margin-top: 10px;
        line-height: 24px;

        .content {
          display: block;
          border-bottom: 1px solid #e6e6e6;

          input {
            width: 100%;
            padding: 8px 30px 10px 10px;
            box-sizing: border-box;
          }

          .unit {
            display: inline-block;
            margin-left: -30px;
          }
        }
      }
    }
  }

  .btns {
    margin: 0;
    text-align: center;
    //margin-top: 30px;
  }
}

/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #303133;
}
</style>
